
import Group from 'vux/src/components/group/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'

import wx from 'weixin-js-sdk'
import global_ from './global'
export default {
name: 'widhdraw',
components: {
Group,
Confirm,
Alert,
XButton,
XInput,
Selector
},
data () {
return {
isShow:false,
opid: '',
amount: '',
fee: 0.00,
availwd: 0.00,
showAvailwd: true,
showFee: false,
showAlert: false,
disableButton: false,
type: 'wallet_withdraw',
type_list: [{key: 'wallet_withdraw', value: '微信零钱'}, {key: 'bank_withdraw', value: '银行卡'}],
bname: '',
baccount: '',
bank: '',
bank_list: ['工商银行', '农业银行', '中国银行', '建设银行', '招商银行', '邮储银行', '交通银行', '浦发银行', '民生银行', '兴业银行', '平安银行', '中信银行', '华夏银行', '广发银行', '光大银行', '北京银行', '宁波银行']
}
},
methods: {







amountChange () {
if(this.amount == ''){
this.showAvailwd = true
this.showFee = false
this.showAlert = false
this.disableButton = true
this.showAlertWechat = false
this.showAlertBank = false
this.isShow = false
} else if (this.amount%1 == 0 ){
if (((parseFloat(this.amount) < 1.00) || ((parseFloat(this.amount) > 10000.00))) && (this.type === 'wallet_withdraw')) {
this.showAlert = false
this.showAvailwd = false
this.showFee = false
this.disableButton = true
this.showAlertWechat = true
this.showAlertBank = false
this.isShow = false
} else if (((parseFloat(this.amount) < 500.00) || ((parseFloat(this.amount) > 50000.00))) && (this.type === 'bank_withdraw')) {
this.showAlert = false
this.showAvailwd = false
this.showFee = false
this.disableButton = true
this.showAlertWechat = false
this.showAlertBank = true
this.isShow = false
} else if (parseFloat(this.amount) <= parseFloat(this.availwd)) {
this.fee = parseFloat(this.amount) * 0.01 < 50 ? parseFloat(this.amount) * 0.01 : 50
this.showAvailwd = false
this.showFee = true
this.showAlert = false
this.disableButton = false
this.showAlertWechat = false
this.showAlertBank = false
this.isShow = false
} else if (parseFloat(this.amount) > parseFloat(this.availwd)) {
this.showAlert = true
this.showAvailwd = false
this.showFee = false
this.disableButton = true
this.showAlertWechat = false
this.showAlertBank = false
this.isShow = false
}
} else {
this.showAvailwd = false
this.showFee = false
this.showAlert = false
this.disableButton = true
this.showAlertWechat = false
this.showAlertBank = false
this.isShow = true
}
},
withdraw () {
if ((parseFloat(this.amount) + parseFloat(this.fee)) > parseFloat(this.availwd)) {
this.$vux.confirm.show({
title: '',
content: '剩余金额不足以支付提现手续费￥' + this.fee + '当前最大可提现金额为￥' + parseFloat(this.availwd) * 0.99 + '，是否要全部提现？',
onConfirm () {
this.opid = localStorage.getItem('userid')
var obj = {
headers:{
token:localStorage.getItem('token'),
opid:this.opid
}
}
var app = this
var data
if (this.type === 'wallet_withdraw') {
data = {
amount: String(parseFloat(this.availwd) * 0.99),
fee: String(parseFloat(this.availwd) * 0.01) < 50 ? String(parseFloat(this.availwd) * 0.01) : 50
}
} else if (this.type === 'bank_withdraw') {
data = {
amount: String(parseFloat(this.availwd) * 0.99),
fee: String(parseFloat(this.availwd) * 0.01) < 50 ? String(parseFloat(this.availwd) * 0.01) : 50,
bname: this.bname,
bank: this.bank,
baccount: this.baccount
}
}
this.$http.post('/api/v1/payments/' + app.opid + '/orders?type=' + app.type, data,obj)
.then(function (response) {
app.$vux.alert.show({
title: '',
content: '提现请求提交成功'
})
app.$router.push({name: 'wallet'})
})
.catch(function (error) {
if (error.response) {
console.log(error.response.data)
if (error.response.data.error_message) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
}
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}
})
} else {
this.opid = localStorage.getItem('userid')
var obj = {
headers:{
token:localStorage.getItem('token'),
opid:this.opid
}
}
var app = this
var data
if (this.type === 'wallet_withdraw') {
data = {
amount: String(this.amount),
fee: String(this.fee)
}
} else if (this.type === 'bank_withdraw') {
data = {
amount: String(this.amount),
fee: String(this.fee),
bname: this.bname,
bank: this.bank,
baccount: this.baccount
}
}
this.$http.post('/api/v1/payments/' + app.opid + '/orders?type=' + app.type, data,obj)
.then(function (response) {
app.$vux.alert.show({
title: '',
content: '提现请求提交成功'
})
app.$router.push({name: 'wallet'})
})
.catch(function (error) {
if (error.response) {
console.log(error.response.data)
if (error.response.data.error_message) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string
})
}
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}
}
},
mounted () {
setTimeout(() => {
var timestamp = parseInt(new Date().getTime() / 1000)
var url
var u = navigator.userAgent
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
var app = this
this.$http.get('static/config.json').then(response => {
var config = response.data
if (isiOS) {
url = config.host + global_.entryUrl
} else {
url = config.host + app.$route.path
}
var noncestr = Math.random().toString(36).substr(2)
app.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + url)
.then(function (response) {
wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: config.appId, // 必填，公众号的唯一标识
timestamp: timestamp, // 必填，生成签名的时间戳
nonceStr: noncestr, // 必填，生成签名的随机串
signature: response.data, // 必填，签名
jsApiList: [ 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'getLocalImgData', 'checkJsApi' ] 
})
wx.error(function (res) {
alert(res.errMsg)
})
})
.catch(function (error) {
alert('服务器错误，请稍后重试')
if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}, response => {
console.log('数据加载失败')
})
}, 500)
},
created () {
this.opid = localStorage.getItem('userid')
var obj = {
headers:{
token:localStorage.getItem('token'),
opid:this.opid
}
}
var app = this
this.$http.get('/api/v1/payments/' + app.opid + '/wallet',obj)
.then(function (response) {
app.availwd = parseFloat(response.data.availwd)
})
.catch(function (error) {
if (error.response) {
console.log(error.response.data)
if (error.response.data.error_message) {
app.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).faultstring,
type: 'cancel',
time: '1000'
})
}
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
var url = '/api/v1/experts/'
this.$http.get(url + app.opid,obj)
.then(function (response) {
if (response.data.detail) {
app.bname = response.data.detail.name
}
})
.catch(function (error) {
if (error.response) {
console.log(error.response.data)
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/withdraw.vue